'use strict';
import Mustache from 'mustache';
import $ from 'jquery';
import debounce from 'lodash/debounce';
import slickLightbox from '../vendor/slick-lightbox';
import compLib from '../complib';

function slugify(text) {
	return text.toString().toLowerCase()
		.replace(/ä/g, 'a') // Replace scands
		.replace(/ö/g, 'o') // Replace scands
		.replace(/å/g, 'a') // Replace scands
		.replace(/\s+/g, '_') // Replace spaces with -
		.replace(/[^\w-]+/g, '') // Remove all non-word chars
		.replace(/--+/g, '') // Replace multiple - with single -
		.replace(/^-+/, '') // Trim - from start of text
		.replace(/-+$/, ''); // Trim - from end of text
}

export default function (API) {

	compLib.init();

	const inspired = {

		init: function (compLib) {

			API.log('INIT Inspired');

			if (!Object.prototype.hasOwnProperty.call(window, 'inspired'))
				window.inspired = { filterparams: { offset: 0 }, infiniteScroll: false, staticfilterparams: {} };

			const singlePage = document.querySelector('#inspired-root').getAttribute('data-is-single-page') === 'true';
			inspired.singlePage = singlePage;

			compLib.mergeState(inspired.initUrlParamValues());

			inspired.initPageSize();

			inspired.listFooterObject = document.querySelector('.pagination-footer .load-more');

			window.inspired.fadeout = function () {
				setTimeout(inspired.delayedFadeout, 300)
			}

			window.inspired.fadein = function () {
				inspired.fadeIn();
			}

			window.inspired.refresh = debounce(function () {

				const userFilterParams = $.extend({}, window.inspired.filterparams);

				$.each(userFilterParams, (key, val) => {
					// filter empty values so they don't override static params
					if ((Array.isArray(val) || typeof val === 'string') && !val.length) {
						delete userFilterParams[key];
					}
				});

				const filterparams = Object.assign({}, window.inspired.staticfilterparams, userFilterParams);

				inspired.initPageSize();
				// show load spinner
				if (inspired.listFooterObject) {
					inspired.listFooterObject.classList.add('loading');
				}

				// Update partial search params to query
				const isInspiredPage =
					document.getElementsByClassName('static-category-listing').length === 0
					&& document.getElementsByClassName('static-category-lander').length === 0
					&& document.getElementsByClassName('inspired-filters').length;

				if (!singlePage && isInspiredPage) {

					let urlParam = inspired.customEncodeUrl(window.inspired.filterparams);
					const originalQuery = new URLSearchParams(window.location.search);
					const query = new URLSearchParams(window.location.search);
					const address = new URL(window.location.href);

					const paramOrder = Array.from(query.keys()).reduce((acc, key, i) => {
						acc[key] = i;
						return acc;
					}, {f: 1001, s: 1002, o: 1003})

					query.delete('f');
					query.delete('s');
					query.delete('o');

					const sortedParams = [...query.entries(), ...Object.entries(urlParam)].sort((a, b) => {
						return paramOrder[a[0]] - paramOrder[b[0]];
					}).filter(([key, val]) => {
						if (['f', 's', 'o'].includes(key)) {
							return val ? true : false;
						}
						return true;
					});

					// query.set() doesn't maintain order when using toString() to get the full query string.
					// query.sort() doesn't allow for custom sorting.
					const urlActiveParamsString = sortedParams.map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`).join('&');
					// If params have not been manipulated, toString() will return the same string as the original query.
					const urlOriginalParamsString = originalQuery.toString();

					if (urlActiveParamsString !== urlOriginalParamsString) {
						address.search = urlActiveParamsString;
						history.replaceState(null, '', address.href);
					}

				}

				$.ajax({
					url: '/stage-ajax/filter-inspired-articles/',
					type: 'GET',
					data: {
						'currentPage': $('body').data('uuid'),
						'stage-language': 'fi_FI',
						filterparams
					},
					dataType: 'html',
				})
					.done(function (response) {

						const responseObject = JSON.parse(response);
						const pagination = responseObject.pagination;
						let articles = responseObject.articles;

						if (window.inspired.loadingMore) {
							window.inspired.articles = window.inspired.articles.concat(articles)
							window.inspired.pagination.currentCount += pagination.currentCount;
							window.inspired.pagination.hasMoreContent = pagination.hasMoreContent;
						}
						else {
							window.inspired.articles = articles;
							window.inspired.pagination = pagination;
						}

						inspired.render();
						//inspired.persist(); // Store pulled data to sessionStorage when data changes

						// hide load spinner
						window.inspired.loadingMore = false;
						if (inspired.listFooterObject)
							inspired.listFooterObject.classList.remove('loading')

					});
			}, 500);

			window.inspired.reset = function () {
				window.inspired.filterparams = {};
				window.inspired.refresh();
			}

			if (singlePage) {
				inspired.initLightBox();
				window.inspired.refresh();
			}
			else {

				// let refresh = true;
				// if(!window.inspired.forceRefresh)
				//   refresh = inspired.retrieve() ? false : true;

				// if(refresh)
				window.inspired.refresh();
				// else
				//   inspired.render();

				inspired.initOrderBy();
				inspired.calculateFooterOffset();

				document.addEventListener('scroll', inspired.callCheckScroll, { passive: true });

				let resetSwitch = document.querySelector('#inspired-2018 .cl-toolsheet .cl-toolsheet-foot .reset-action');
				resetSwitch.onclick = window.inspired.reset;

				inspired.initInfiniteScroll();
				if (window.inspired.infiniteScroll)
					inspired.enableInfiniteScroll();
			}
		},
		rewriteUrls(articles) {
			if (!window.inspired.url) return articles;
			return articles.map(a => {

				const href = [
					'', // root
					a.hrefRaw.lang, // fi
					window.inspired.url, // rewrite path
					a.hrefRaw.slug, // article slug
				].join('/').replace(/\/\//g, '/')

				return Object.assign(a, { href });
			});
		},
		rebuildPreviewItems: function () {
			const images = document.querySelectorAll('#inspired-2018.embedded .inspired-article-main-image');
			for (var imIndex = 0; imIndex < images.length; imIndex++) {
				try {
					const imageParent = images[imIndex];
					const imgSrc = imageParent.querySelector('img').src;
					imageParent.style.backgroundImage = `url(${imgSrc})`;
				} catch (e) {
					console.log(e);
				}
			}
		},
		delayedFadeout: function () {
			document.querySelector('#inspired-2018').classList.add('fadeout')
		},
		fadeIn: function () {
			document.querySelector('#inspired-2018').classList.remove('fadeout')
		},
		initPageSize: function () {
			if (inspired.singlePage) {
				window.inspired.filterparams.orderby = 'popularity';
				window.inspired.filterparams.limit = 2;
			} else {
				window.inspired.filterparams.limit = window.inspired.defaultPageSize;
			}
		},
		initLightBox: function () {
			slickLightbox();
			$('.bread').slickLightbox(
				{
					// background: 'rgba(0,0,0,.8)', closeOnEscape: true, closeOnBackdropClick: true,destroyTimeout: 500, shouldOpen: null, imageMaxHeight: 0.9
					// navigateByKeyboard: true, src: false, caption: false, captionPosition: 'dynamic', images: false, slick: {}, useHistoryApi: false,
					itemSelector: 'a.slightbox',
					layouts: {
						closeButton: '<button type="button" class="slick-lightbox-close"><span class="close-icon" aria-hidden="true"></span></button>'
					},
				}
			).on({
				'show.slickLightbox': function () {
					$('body').addClass('slick-lightbox-open');
				},
				'hide.slickLightbox': function () {
					$('body').removeClass('slick-lightbox-open');
				}
			});
		},
		initOrderBy: function () {
			let orderby = document.querySelectorAll('#inspired-2018 .inspired-order')

			for (var obIndex = 0; obIndex < orderby.length; obIndex++) {
				for (var op = 0; op < orderby[obIndex].options.length; op++) {
					if (orderby[obIndex].options[op].value === window.inspired.filterparams.orderby) {
						orderby[obIndex].selectedIndex = op;
					}
				}
				orderby[obIndex].onchange = function () {
					window.inspired.filterparams.orderby = this.options[this.selectedIndex].value;
					window.inspired.filterparams.offset = 0;
					window.inspired.fadeout();
					window.inspired.refresh();
				}
			}
		},

		initUrlParamValues: function () {
			inspired.initCompressDictionary();
			let query = new URLSearchParams(window.location.search);
			let params = {};
			let mergeState = {};
			for (let [key, val] of query.entries()) {
				params[key] = val;
			}
			for (let [key, val] of Object.entries(inspired.customDecodeUrl(params))) {
				mergeState[key] = val;
				window.inspired.filterparams[key] = val;
			}
			return mergeState;
		},
		loadMore: function () {
			window.inspired.infiniteScroll = true;
			if (window.inspired.pagination.hasMoreContent) {
				if (!window.inspired.loadingMore) {
					window.inspired.loadingMore = true;
					window.inspired.filterparams.offset += window.inspired.filterparams.limit;
					window.inspired.refresh();
				}
			}
		},
		checkScroll: function () {
			if (window.inspired.infiniteScroll && inspired.footerOffset < (inspired.getScrollPos() + 500)) inspired.loadMore();
		},
		footerOffset: 0,
		scrollEndTimer: new Date(),
		callCheckScroll: function () {
			if (inspired.scrollEndTimer < new Date()) {
				inspired.calculateFooterOffset();
				inspired.scrollEndTimer = new Date();
				inspired.scrollEndTimer.setSeconds(inspired.scrollEndTimer.getSeconds() + 1);
				setTimeout(inspired.checkScroll, 1000);
			}
		},
		calculateFooterOffset: function () {
			let e = inspired.listFooterObject;
			inspired.footerOffset = 0;
			do {
				if (e) {
					inspired.footerOffset += e.offsetTop;
					e = e.offsetParent;
				}
			} while (e);
		},
		initInfiniteScroll: function () {
			let loadMoreButton = document.querySelector('#inspired-2018 .pagination-footer #request-more');
			if (loadMoreButton) loadMoreButton.onclick = inspired.enableInfiniteScroll;
		},
		enableInfiniteScroll: function () {
			window.inspired.infiniteScroll = true;
			//inspired.persist();
			document.querySelector('#inspired-2018').classList.add('infinite-scroll')
			inspired.loadMore();
		},
		getScrollPos: function () {
			var h = document.documentElement, b = document.body;
			return (h['scrollTop'] || b['scrollTop']) + h.clientHeight;
		},
		render: function () {
			let inspiredPreviewTemplate, inspiredListingHeaderTemplate;

			inspiredPreviewTemplate = document.querySelector('#inspired-article-list-item').innerHTML;
			inspiredListingHeaderTemplate = document.querySelector('#inspired-article-paging-header').innerHTML;

			if (!inspired.singlePage) {

				const defaultAction = document.querySelector('#inspired-2018 .cl-toolsheet .cl-toolsheet-foot .default-action .filter-label');

				if (window.inspired.pagination && window.inspired.pagination.fullCount)
					defaultAction.innerText = defaultAction.getAttribute('data-raw-title') + ' (' + window.inspired.pagination.fullCount + ')';

				const filterControls = ['articleType', 'brand', 'sport'];
				var fullFilterCount = 0;
				for (var fc in filterControls) {
					var fcArray = window.inspired.filterparams[filterControls[fc]];
					fullFilterCount += Array.isArray(fcArray) ? fcArray.length : 0;
				}

				const mobileControlTitle = document.querySelector('.cl-mobile-control-title')
				mobileControlTitle.innerHTML = mobileControlTitle.getAttribute('data-raw-title') + (fullFilterCount ? ' (' + fullFilterCount + ')' : '');
			}
			if (document.querySelector('#articleList')) {
				document.querySelector('#articleList').innerHTML = Mustache.render(inspiredPreviewTemplate, {
					articles: window.inspired.articles
				})
			}
			if (document.querySelector('#articleListPagingHeader')) {
				document.querySelector('#articleListPagingHeader').innerHTML = Mustache.render(inspiredListingHeaderTemplate, window.inspired.pagination)
			}
			inspired.rebuildPreviewItems();
			setTimeout(inspired.fadein, 500)
		},
		fadein: function () { window.inspired.fadein() },
		persistKey: 'inspired',
		persistMembers: ['articles', 'pagination', 'filterparams'],
		// retrieveCalled: false,
		persist: function () {
			for (let key of inspired.persistMembers) {
				sessionStorage.setItem(inspired.dataKey(key), JSON.stringify(window.inspired[key]));
			}
		},
		retrieve: function () {

			let res = false;
			for (let key of inspired.persistMembers) {
				let data = JSON.parse(sessionStorage.getItem(inspired.dataKey(key)));

				if (data)
					window.inspired[key] = data;

				if (data && key === 'articles')
					res = true;
			}

			return res;
		},
		dataKey: function (key) {
			return window.inspired.instanceID + '/' + inspired.persistKey + '/' + (inspired.singlePage * 1) + '/' + key;
		},
		compressKeyMap: {
			articleType: 'a',
			sport: 's',
			brand: 'b',
			freeText: 'f',
		},
		slugifyDict: {},
		slugifyDictReverse: {},
		//<input type="checkbox" id="sport-yW6GjEG7SLGGZ9Ij40WmbA" name="yW6GjEG7SLGGZ9Ij40WmbA" data-raw-title="Pyöräily" checked="checked">
		initCompressDictionary: function () {
			['sport', 'brand'].map(id => {
				const items = document.querySelectorAll(`#${id} input[type='checkbox']`);
				for (var itemIndex = 0; itemIndex < items.length; itemIndex++) {

					if (!items[itemIndex].dataset)
						continue;

					let slug = slugify(items[itemIndex].dataset.rawTitle);
					inspired.slugifyDict[slug] = {
						value: items[itemIndex].name,
						source: id,
					};
					inspired.slugifyDictReverse[items[itemIndex].name] = slug;
				}
			})

			let buttons = document.querySelectorAll('#articleType li');
			for (var itemIndex = 0; itemIndex < buttons.length; itemIndex++) {
				let checkbox = buttons[itemIndex].querySelector('input[type=\'checkbox\']');
				let label = buttons[itemIndex].querySelector('label').innerText;

				let slug = slugify(label);
				inspired.slugifyDict[slug] = {
					value: checkbox.name,
					source: 'articleType',
				};
				inspired.slugifyDictReverse[checkbox.name] = slug;
			}
		},
		customEncodeUrl: function (filterparams) {
			let compressedFilter = {};
			let search = '';
			let sort = '';
			for (let [key, val] of Object.entries(filterparams)) {
				//console.log('Object.entries', key, val)
				switch (key) {
					case 'articleType':
					case 'sport':
					case 'brand':
						compressedFilter[key] = `${val.map(i => inspired.slugifyDictReverse[i] || i).join('-')}`;
						break;
					case 'freeText':
						search = val;
						break;
					case 'orderby':
						sort = val;
						break;
				}
			}

			let filterResult = Object.values(compressedFilter).filter(v => v !== '').join('-');

			return { f: filterResult, s: search.length ? search : null, o: sort };
		},
		customDecodeUrl: function (filterparams) {

			const result = {};
			if (filterparams.f) {

				filterparams.f.split('-').map(item => {

					let entry = inspired.slugifyDict[item];
					if (entry) {
						if (!Array.isArray(result[entry.source])) {
							result[entry.source] = [];
						}
						result[entry.source].push(entry.value);
					}
				});
			}
			if (filterparams.s) {
				result['freeText'] = filterparams.s;
			}
			if (filterparams.o) {
				result['orderby'] = filterparams.o;
			}
			return result;
		},
	}

	if (document.querySelector('#inspired-2018')) {
		inspired.init(compLib);

		if (window.inspired.staticfilterparams.onlyArticles) {
			document.querySelector('#inspired-2018 .inspired-flip .page').style.display = 'none'
		}
	}
}
